import { render } from "./layout_20230210_5f79.vue?vue&type=template&id=5b47cecb&scoped=true"
const script = {}

import "./layout_20230210_5f79.vue?vue&type=style&index=0&id=5b47cecb&scoped=true&lang=less"

import exportComponent from "D:\\Git仓库\\象新力官网\\html_xxldx_xxlx_xxlg\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b47cecb"]])

export default __exports__